import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import styles from './Header.module.css';
import { useNavigate } from "react-router-dom";
import { useRef } from 'react';

const Header: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const [scrolled, setScrolled] = useState<boolean>(false);
    const { isAuthenticated, user, logout } = useAuth();
    const navigate = useNavigate();
    const redirectLink = useRef<string | null>(null);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 10;
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrolled]);

    const handleLogout = (): void => {
        logout();
        setMenuOpen(false);
    };

    const handleLogin = (): void => {
        setMenuOpen(false);
        navigate('/login');
    };

    const handleLink = (link: string): void => {
        setMenuOpen(false);
        navigate(link);
    };

    return (
        <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
            <div className={styles.logo}
                 onClick={() => handleLink('/')}
            >
                Vivera Blog

            </div>

            <button
                className={`${styles.menuButton} ${menuOpen ? styles.open : ''}`}
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Меню"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div className={`${styles.navContainer} ${menuOpen ? styles.open : ''}`}>
                <nav className={styles.nav}>
                    <button onClick={() => handleLink('/')} className={styles.linkButton}>Главная</button>
                    <button onClick={() => handleLink('/about')} className={styles.linkButton}>О проекте</button>
                    <button onClick={() => handleLink('/contact')} className={styles.linkButton}>Контакты</button>
                    <button onClick={() => handleLink('/create_post')} className={styles.linkButton}>Добавить пост</button>
                </nav>

                <div className={styles.authSection}>
                    {isAuthenticated ? (
                        <div className={styles.userMenu}>
                            <span className={styles.userEmail}
                                  onClick={() => handleLink(`/author/${user?.id}`)}
                            >{user?.email}
                            </span>
                            <button onClick={handleLogout} className={styles.logoutButton}>Выйти</button>
                        </div>
                    ) : (
                        <button onClick={handleLogin} className={styles.loginButton}>Вход</button>
                    )}
                </div>

                <div className={styles.search}>
                    <input type="text" placeholder="Поиск..."/>
                </div>
            </div>
        </header>
    );
};

export default Header;